import * as actionTypes from './actionTypes'
import * as API from '../api/Subuser'

export const addSubUserAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.ADD_SUBUSER_REQUEST, payload: data})
        return API.SubUserAddApi(data)
            .then(response => {            	
            	dispatch({type: actionTypes.ADD_SUBUSER_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.ADD_SUBUSER_ERROR, payload:error})    
            })
    }
}

export const SubUserListAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.SUBUSER_LIST_REQUEST, payload: data})
        return API.SubUserListApi(data)
            .then(response => {             
                dispatch({type: actionTypes.SUBUSER_LIST_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.SUBUSER_LIST_ERROR, payload:error})    
            })
    }
}

export const SubUserStatusAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.SUBUSER_STATUS_REQUEST, payload: data})
        return API.SubUserStatusApi(data)
            .then(response => {             
                dispatch({type: actionTypes.SUBUSER_STATUS_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.SUBUSER_STATUS_ERROR, payload:error})    
            })
    }
}









// WEBPACK FOOTER //
// ./src/actions/Subuser.js